
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.335 1.07h8.285l-8.6 25.484a1.321 1.321 0 01-1.252.898H1.32a1.319 1.319 0 01-1.25-1.74L8.083 1.968a1.321 1.321 0 011.252-.899z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M21.375 18.162H8.236a.608.608 0 00-.415 1.053l8.443 7.88c.245.23.57.357.905.357h7.44l-3.234-9.29z","fill":"#E6E7E9"}}),_c('path',{attrs:{"d":"M9.335 1.07a1.31 1.31 0 00-1.255.915l-8 23.705a1.318 1.318 0 001.243 1.762h6.614a1.414 1.414 0 001.086-.923l1.595-4.702 5.7 5.316c.238.197.537.307.847.31h7.412l-3.25-9.29-9.477.002 5.8-17.096H9.335z","fill":"url(#paint0_linear_18980_22332)"}}),_c('path',{attrs:{"d":"M19.918 1.967a1.319 1.319 0 00-1.25-.898H9.434a1.32 1.32 0 011.25.898l8.013 23.744a1.319 1.319 0 01-1.25 1.742h9.235a1.32 1.32 0 001.25-1.742L19.917 1.967z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_18980_22332","x1":"15.042","y1":"14.871","x2":"13.052","y2":"15.544","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-opacity":".3"}}),_c('stop',{attrs:{"offset":".071","stop-opacity":".2"}}),_c('stop',{attrs:{"offset":".321","stop-opacity":".1"}}),_c('stop',{attrs:{"offset":".623","stop-opacity":".05"}}),_c('stop',{attrs:{"offset":"1","stop-opacity":"0"}})])])])
          )
        }
      }
    